const endpoint = 'https://donate-framed.pow.io';
export async function getDonationTotal() {
    const res = await fetch(`${endpoint}/total`);
    if (!res.ok) {
        throw new Error('Failed to fetch donations');
    }
    const result = await res.json();
    return result?.total;
}
export async function submitDonation(amount) {
    const res = await fetch(`${endpoint}/donate`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ amount }),
    });
    if (!res.ok) {
        const err = await res.json();
        throw new Error(err.error || 'Failed to submit donation');
    }
    const result = await res.json();
    return result.total;
}
